/* The native Minimog form owns regular writes; this layer adds verified multi-item upsells when selected. */
(() => {
  const english = document.documentElement.lang.toLowerCase().startsWith('en');
  const copy = (ar, en) => english ? en : ar;
  function init(root) {
    if (!root || root.dataset.scReady) return;
    root.dataset.scReady = 'true';
    const cleanups = [];
    const listen = (target, type, fn, options) => {
      if (!target) return;
      target.addEventListener(type, fn, options);
      cleanups.push(() => target.removeEventListener(type, fn, options));
    };
    const form = root.querySelector('[data-sc-form]');
    const qty = root.querySelector('[data-sc-quantity]');
    const primary = root.querySelector('[data-sc-primary]');
    const nativeForm = root.querySelector('product-form');
    const formStatus = root.querySelector('[data-sc-form-status]');
    const variantSelect = root.querySelector('[data-sc-variant-select]');
    const variantChoices = [...root.querySelectorAll('[data-sc-variant-choice]')];
    const variantId = root.querySelector('[data-sc-variant-id]');
    const price = root.querySelector('[data-sc-price]');
    const compare = root.querySelector('[data-sc-compare]');
    const saving = root.querySelector('[data-sc-saving]');
    const availability = root.querySelector('[data-sc-availability]');
    const stickyPrice = root.querySelector('[data-sc-sticky-price]');
    const stickyCompare = document.createElement('del');
    stickyCompare.className = 'sc-sticky-compare';
    stickyCompare.innerHTML = compare?.innerHTML || '';
    stickyCompare.hidden = !compare || compare.hidden || !compare.textContent.trim();
    stickyPrice?.before(stickyCompare);
    const stickyInstallments = root.querySelector('[data-sc-sticky-installments]');
    const stickyTitle = root.querySelector('[data-sc-sticky-title]');
    const stickySubmit = root.querySelector('[data-sc-sticky-submit]');
    const productName = root.querySelector('[data-sc-product-name]');
    const templateHtml = (kind, id) => root.querySelector(`[data-sc-variant-${kind}="${CSS.escape(id)}"]`)?.innerHTML.trim() || '';
    const syncVariant = () => {
      if (!variantSelect) return;
      const option = variantSelect.selectedOptions[0];
      const id = option.value;
      const available = option.dataset.available === 'true';
      const readyToShip = option.dataset.ready === 'true';
      variantChoices.forEach(button => {
        const selected = button.dataset.variantId === id;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-checked', String(selected));
      });
      const priceHtml = templateHtml('price', id);
      const compareHtml = templateHtml('compare', id);
      const savingHtml = templateHtml('saving', id);
      const installmentsHtml = templateHtml('installments', id);
      const applyVariantId = () => {
        variantId.value = id;
        variantId.setAttribute('value', id);
      };
      applyVariantId();
      setTimeout(applyVariantId, 0);
      price.innerHTML = priceHtml;
      stickyPrice.innerHTML = priceHtml;
      stickyCompare.innerHTML = compareHtml;
      stickyCompare.hidden = !compareHtml;
      if (stickyInstallments) stickyInstallments.innerHTML = installmentsHtml;
      compare.innerHTML = compareHtml;
      compare.hidden = !compareHtml;
      saving.innerHTML = savingHtml;
      saving.hidden = !savingHtml;
      availability.classList.toggle('is-unavailable', !available);
      availability.dataset.readyToShip = String(readyToShip);
      availability.querySelector('span:last-child').textContent = available ? copy("متوفر","In stock") : copy("غير متوفر حاليًا","Currently unavailable");
      primary.disabled = !available;
      primary.querySelector('.m-add-to-cart--text').textContent = available ? copy("أضف للسلة","Add to cart") : copy("غير متوفر","Unavailable");
      if (stickySubmit) {
        stickySubmit.disabled = !available;
        stickySubmit.textContent = available ? copy("أضف للسلة","Add to cart") : copy("غير متوفر","Unavailable");
      }
      qty.min = option.dataset.min || '1';
      qty.step = option.dataset.step || '1';
      if (option.dataset.max && Number(option.dataset.max) > 0) qty.max = option.dataset.max;
      else qty.removeAttribute('max');
      qty.value = qty.min;
      const base = root.dataset.profileBase || '';
      const displayTitle = option.dataset.title && option.dataset.title !== 'Default Title' ? `${base} · ${option.dataset.title}` : base;
      if (productName) productName.textContent = `${copy("الموديل:", "Model:")} ${displayTitle}`;
      if (stickyTitle) stickyTitle.textContent = displayTitle;
      if (/^\d+(?:\.\d+)?MP$/i.test(option.dataset.title || '')) {
        root.querySelectorAll('[data-sc-resolution],[data-sc-resolution-detail]').forEach(node => { node.textContent = option.dataset.title; });
      }
      const currentPriceCell = root.querySelector(`[data-sc-field="price"] [data-sc-col="${CSS.escape(root.dataset.productId)}"]`);
      if (currentPriceCell) currentPriceCell.innerHTML = `<span class="sc-table-price">${priceHtml}</span>`;
      if (option.dataset.image && mainImage && zoom) {
        mainImage.src = option.dataset.image;
        mainImage.removeAttribute('srcset');
        zoom.dataset.scFull = option.dataset.imageFull || option.dataset.image;
      }
      formStatus.textContent = '';
    };
    variantChoices.forEach(button => listen(button, 'click', () => {
      if (!variantSelect || button.disabled) return;
      variantSelect.value = button.dataset.variantId;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    root.querySelectorAll('[data-sc-quantity-step]').forEach(button => listen(button, 'click', () => {
      const step = Number(qty.step) || 1;
      const min = Number(qty.min) || 1;
      const max = qty.max ? Number(qty.max) : Infinity;
      qty.value = Math.max(min, Math.min(max, (Number(qty.value) || min) + Number(button.dataset.scQuantityStep) * step));
      qty.dispatchEvent(new Event('change', {bubbles:true}));
      formStatus.textContent = '';
    }));
    listen(form, 'submit', async event => {
      if (variantSelect) {
        variantId.value = variantSelect.value;
        variantId.setAttribute('value', variantSelect.value);
      }
      if (nativeForm.classList.contains('m-spinner-loading')) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      if (!qty.checkValidity()) { event.preventDefault(); event.stopImmediatePropagation(); formStatus.textContent = copy("اختر كمية صحيحة ضمن الكمية المتاحة.","Choose a valid quantity within the available stock."); qty.reportValidity(); return; }
      const selectedAddons = [...root.querySelectorAll('[data-sc-addon-toggle]:checked')].map(toggle => {
        const select = toggle.closest('.sc-upsell-card')?.querySelector('[data-sc-addon-variant]');
        if (!select?.value) return null;
        const multiplier = Math.max(1, Number(select.dataset.scAddonQuantity) || 1);
        const matchProductQuantity = select.dataset.scAddonMatchProductQuantity === 'true';
        return { id: select.value, quantity: multiplier * (matchProductQuantity ? (Number(qty.value) || 1) : 1) };
      }).filter(Boolean);
      if (selectedAddons.length) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } }));
        const items = [{ id: Number(variantId.value), quantity: Number(qty.value) || 1 }, ...selectedAddons.map(addon => ({ id: Number(addon.id), quantity: addon.quantity }))];
        nativeForm.classList.add('m-spinner-loading');
        primary.disabled = true;
        formStatus.textContent = copy("جاري إضافة المنتج والملحقات…","Adding your product and accessories\u2026");
        try {
          const config = typeof fetchConfig === 'function' ? fetchConfig() : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
          const response = await fetch(window.MinimogSettings?.routes?.cart_add_url || `${window.Shopify.routes.root}cart/add.js`, { ...config, body: JSON.stringify({ items, sections }) });
          const cart = await response.json();
          if (!response.ok || cart.status || cart.errors) throw new Error(cart.description || cart.message || copy("تعذر إضافة أحد الخيارات.","One of the selected options could not be added."));
          window.MinimogEvents?.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart });
          formStatus.textContent = copy("تمت إضافة المنتج والخيارات المحددة للسلة.","Product and selected options added to cart.");
          document.querySelector('m-cart-drawer')?.open(primary);
        } catch (error) {
          formStatus.textContent = error.message || copy("تعذر إكمال الإضافة. حاول مرة أخرى.","Could not add to cart. Please try again.");
        } finally {
          nativeForm.classList.remove('m-spinner-loading');
          primary.disabled = false;
        }
        return;
      }
      formStatus.textContent = '';
    }, true);
    root.querySelectorAll('[data-sc-addon-toggle]').forEach(toggle => listen(toggle, 'change', () => {
      const card = toggle.closest('.sc-upsell-card');
      const select = card?.querySelector('[data-sc-addon-variant]');
      const choices = card?.querySelector('[data-sc-addon-choices]');
      if (select) select.disabled = !toggle.checked;
      if (choices) {
        choices.hidden = !toggle.checked;
        choices.querySelectorAll('[data-sc-addon-choice]').forEach(button => { button.disabled = !toggle.checked; });
      }
    }));
    root.querySelectorAll('[data-sc-addon-choice]').forEach(button => listen(button, 'click', () => {
      if (button.disabled) return;
      const card = button.closest('.sc-upsell-card');
      const select = card?.querySelector('[data-sc-addon-variant]');
      if (!select) return;
      select.value = button.dataset.variantId;
      card.querySelectorAll('[data-sc-addon-choice]').forEach(choice => {
        const selected = choice === button;
        choice.classList.toggle('is-selected', selected);
        choice.setAttribute('aria-checked', String(selected));
      });
    }));
    root.querySelectorAll('.sc-memory-card').forEach(card => {
      const toggle = card.querySelector('[data-sc-addon-toggle]');
      const select = card.querySelector('[data-sc-addon-variant]');
      const buttons = [...card.querySelectorAll('[data-sc-memory-choice]')];
      const sync = () => buttons.forEach(button => {
        const active = toggle.checked && select.value === button.dataset.variantId;
        button.setAttribute('aria-pressed', String(active));
        button.classList.toggle('is-selected', active);
      });
      buttons.forEach(button => listen(button, 'click', () => {
        const active = toggle.checked && select.value === button.dataset.variantId;
        select.value = button.dataset.variantId;
        toggle.checked = !active;
        select.disabled = !toggle.checked;
        sync();
      }));
      listen(toggle, 'change', sync);
      sync();
    });
    const delivery = root.querySelector('[data-sc-delivery]');
    if (delivery) {
      const riyadhDateNode = delivery.querySelector('[data-sc-delivery-riyadh]');
      const otherDateNode = delivery.querySelector('[data-sc-delivery-other]');
      const cutoffNode = delivery.querySelector('[data-sc-cutoff]');
      const riyadhParts = date => Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Riyadh', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' }).formatToParts(date).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
      const localDay = parts => new Date(Date.UTC(parts.year, parts.month - 1, parts.day, 12));
      const nextWorkday = date => { const next = new Date(date); do next.setUTCDate(next.getUTCDate() + 1); while (next.getUTCDay() === 5); return next; };
      const addWorkdays = (date, days) => { let value = new Date(date); for (let index = 0; index < days; index += 1) value = nextWorkday(value); return value; };
      const formatDate = new Intl.DateTimeFormat(english ? 'en-GB' : 'ar-SA-u-ca-gregory', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' });
      const updateDelivery = () => {
        const now = new Date();
        const parts = riyadhParts(now);
        const today = localDay(parts);
        const riyadhExpected = addWorkdays(today, 1);
        const otherCitiesExpected = addWorkdays(today, 2);
        riyadhDateNode.textContent = formatDate.format(riyadhExpected);
        otherDateNode.textContent = formatDate.format(otherCitiesExpected);
        cutoffNode.textContent = english ? 'Estimated delivery:' : 'الوصول المتوقع:';
      };
      updateDelivery();
      const deliveryTimer = setInterval(updateDelivery, 60000);
      cleanups.push(() => clearInterval(deliveryTimer));
    }
    listen(variantSelect, 'change', syncVariant);
    const table = root.querySelector('[data-sc-table]');
    if (table) {
      const rival = root.querySelector('[data-sc-rival]');
      const diffs = root.querySelector('[data-sc-differences]');
      const narrow = matchMedia('(max-width:749px)');
      const current = root.dataset.productId;
      const status = root.querySelector('[data-sc-comparison-status]');
      const syncComparison = () => {
        table.querySelectorAll('[data-sc-col]').forEach(cell => cell.classList.toggle('sc-mobile-hidden',cell.dataset.scCol !== current && cell.dataset.scCol !== rival.value));
        let count = 0;
        table.querySelectorAll('[data-sc-row]').forEach(row => {
          const values = [...row.querySelectorAll('[data-sc-col]')].filter(cell => !narrow.matches || !cell.classList.contains('sc-mobile-hidden')).map(cell => cell.dataset.scValue || cell.textContent.replace(/\s+/g,' ').trim());
          const same = values.length > 1 && values.every(value => value === values[0]);
          row.hidden = diffs.checked && same;
          if (!row.hidden) count++;
        });
        status.textContent = diffs.checked ? copy("تم عرض صفوف الفروقات فقط.","Only differences are shown.") : copy("تم عرض جميع المواصفات في المقارنة.","All comparison specifications are shown.");
      };
      table.dataset.enhanced = 'true';
      root.querySelector('[data-sc-difference-control]').hidden = false;
      root.querySelector('[data-sc-comparison-control]').hidden = false;
      listen(rival,'change',syncComparison);listen(diffs,'change',syncComparison);listen(narrow,'change',syncComparison);
      syncComparison();
    }
    const mainImage = root.querySelector('[data-sc-main-image]');
    const zoom = root.querySelector('[data-sc-zoom]');
    const dialog = root.querySelector('[data-sc-gallery-dialog]');
    const dialogImage = dialog?.querySelector('img');
    const description = root.querySelector('.sc-product-description');
    if (description) {
      const normalize = value => value.replace(/\s+/g, ' ').trim().toLowerCase();
      if (root.dataset.cameraIndoor === 'true') {
        description.innerHTML = description.innerHTML
          .replace(/كاميرة/g, 'كاميرا')
          .replace(/بأمكانك/g, 'بإمكانك')
          .replace(/تضل/g, 'تظل')
          .replace(/الصخصوية/g, 'الخصوصية')
          .replace(/وضح السكون/g, 'وضع السكون')
          .replace(/وتثبيتها المغناطيسي/g, 'وقاعدتها المغناطيسية')
          .replace(/تثبيته على الحائط/g, 'تثبيتها على الحائط')
          .replace(/:مميزات الكاميرا/g, '. مميزات الكاميرا:')
          .replace(/بدون أي أسلاك أو كهرب(?=[\s,<])/g, 'بدون أي أسلاك أو كهرباء');
        if (root.dataset.productId === '9312527417621') description.innerHTML = description.innerHTML.replace(/EZVIZ CloudPlay/gi, copy("خدمة التخزين السحابي في تطبيق Arenti", "Arenti cloud storage"));
        if (root.dataset.productId === '8973648560405') description.innerHTML = description.innerHTML.replace(/1080p/gi, '3MP (2K)');
        const legacyFaqHeading = [...description.querySelectorAll('p,h2,h3,h4,b,strong,span,li')].find(block => {
          const value = normalize(block.textContent);
          return value.length < 90 && value.includes('سئلة الشائعة');
        });
        if (legacyFaqHeading) {
          let block = legacyFaqHeading.closest('p,h2,h3,h4,li') || legacyFaqHeading;
          while (block) {
            const next = block.nextSibling;
            block.remove();
            block = next;
          }
        }
        const warrantyMarker = [...description.querySelectorAll('strong,b')].find(block => {
          const value = normalize(block.textContent);
          return value.length < 140 && value.includes('ضمان') && value.includes('سنتين');
        }) || [...description.querySelectorAll('p,li,div')].find(block => {
          const value = normalize(block.textContent);
          return value.length < 140 && value.includes('ضمان') && value.includes('سنتين');
        });
        if (warrantyMarker) {
          let warrantyBlock = warrantyMarker.closest('p,li,h2,h3,h4');
          if (!warrantyBlock) {
            const parent = warrantyMarker.parentElement;
            warrantyBlock = parent && parent !== description && normalize(parent.textContent).length < 160 ? parent : warrantyMarker;
          }
          warrantyBlock.remove();
        }
        [...description.querySelectorAll('p,div,blockquote')].reverse().filter(block => !normalize(block.textContent) && !block.querySelector('img,video,iframe,table,ul,ol')).forEach(block => block.remove());
      }
      if (root.dataset.cameraIndoor !== 'true') {
        const warrantyMarker = [...description.querySelectorAll('strong,b')].find(block => {
          const value = normalize(block.textContent);
          return value.length < 140 && value.includes('ضمان') && value.includes('سنتين');
        }) || [...description.querySelectorAll('p,li,div')].find(block => {
          const value = normalize(block.textContent);
          return value.length < 140 && value.includes('ضمان') && value.includes('سنتين');
        });
        if (warrantyMarker) {
          const warrantyBlock = warrantyMarker.closest('p,li,h2,h3,h4') || warrantyMarker;
          warrantyBlock.remove();
        }
        [...description.querySelectorAll('p,div,blockquote')].reverse().filter(block => !normalize(block.textContent) && !block.querySelector('img,video,iframe,table,ul,ol')).forEach(block => block.remove());
      }
      const items = [...description.querySelectorAll('li')];
      const seen = new Set();
      items.forEach(item => {
        const value = normalize(item.textContent);
        if (!value || seen.has(value)) item.remove();
        else seen.add(value);
      });
      const hasFlexibleInstallation = [...description.querySelectorAll('li')].some(item => normalize(item.textContent).includes('تركيب مرن'));
      if (hasFlexibleInstallation) [...description.querySelectorAll('li')].filter(item => normalize(item.textContent).includes('تثبيت آمن')).forEach(item => item.remove());
    }
    syncVariant();
    root.querySelectorAll('[data-sc-image]').forEach(button => listen(button,'click',() => {
      mainImage.src = button.dataset.scImage;
      mainImage.srcset = button.dataset.scSrcset;
      mainImage.alt = button.dataset.scAlt;
      zoom.dataset.scFull = button.dataset.scFull;
      root.querySelectorAll('[data-sc-image]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
    }));
    const openDialog = () => {
      if (!dialog || typeof dialog.showModal !== 'function') return;
      dialogImage.src = zoom.dataset.scFull;
      dialogImage.alt = mainImage.alt;
      dialog.showModal();
    };
    listen(zoom,'click',openDialog);
    listen(root.querySelector('[data-sc-dialog-close]'),'click',()=>dialog.close());
    listen(dialog,'click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
    const sticky = root.querySelector('[data-sc-sticky]');

    // One quantity source for primary and sticky purchase controls.
    if (sticky && qty) {
      const group = document.createElement('div');
      group.className = 'sc-sticky-quantity';
      group.setAttribute('role','group');
      group.setAttribute('aria-label',copy('الكمية','Quantity'));
      const minus = document.createElement('button');
      const plus = document.createElement('button');
      const input = document.createElement('input');
      minus.type = plus.type = 'button';
      minus.textContent = '−'; plus.textContent = '+';
      minus.setAttribute('aria-label',copy('تقليل الكمية','Decrease quantity'));
      plus.setAttribute('aria-label',copy('زيادة الكمية','Increase quantity'));
      input.type = 'number'; input.inputMode = 'numeric';
      input.setAttribute('aria-label',copy('الكمية','Quantity'));
      group.append(minus,input,plus);
      stickySubmit.before(group);
      const syncQty = () => {
        for (const attr of ['min','max','step']) {
          if(qty.hasAttribute(attr)) input.setAttribute(attr,qty.getAttribute(attr));
          else input.removeAttribute(attr);
        }
        input.value = qty.value;
        minus.disabled = Number(qty.value) <= Number(qty.min || 1);
        plus.disabled = !!qty.max && Number(qty.value) >= Number(qty.max);
      };
      const commitQty = () => {
        const min = Number(qty.min)||1, step = Number(qty.step)||1;
        const max = qty.max ? Number(qty.max) : Infinity;
        const requested = Number(input.value)||min;
        qty.value = Math.max(min,Math.min(max,min+Math.round((requested-min)/step)*step));
        qty.dispatchEvent(new Event('change',{bubbles:true})); syncQty();
      };
      listen(input,'change',commitQty);
      listen(minus,'click',()=>{input.value=Number(qty.value)-(Number(qty.step)||1);commitQty();});
      listen(plus,'click',()=>{input.value=Number(qty.value)+(Number(qty.step)||1);commitQty();});
      listen(qty,'change',syncQty); listen(qty,'input',syncQty);
      listen(variantSelect,'change',syncQty);
      syncQty();
    }
    // Keep every description in the DOM; collapse only the mobile presentation.
    const benefitsMedia = matchMedia('(max-width:749px)');
    root.querySelectorAll('.sc-spec-grid .sc-spec').forEach((card,index) => {
      const title=card.querySelector('strong'), description=card.querySelector('p');
      if(!title || !description) return;
      const trigger=document.createElement('button');
      trigger.type='button'; trigger.className='sc-benefit-trigger';
      description.id = 'sc-benefit-'+root.dataset.sectionId+'-'+index;
      trigger.setAttribute('aria-controls',description.id);
      title.before(trigger); trigger.append(title);
      const syncBenefit=()=>{
        const mobile=benefitsMedia.matches;
        trigger.disabled=!mobile;
        const expanded=!mobile || card.classList.contains('is-benefit-open');
        trigger.setAttribute('aria-expanded',String(expanded));
        description.hidden=!expanded;
      };
      listen(trigger,'click',()=>{card.classList.toggle('is-benefit-open');syncBenefit();});
      listen(benefitsMedia,'change',syncBenefit);syncBenefit();
    });

    if (sticky && primary && 'IntersectionObserver' in window) {
      root.classList.add('sc-mobile-buy-ready');
      cleanups.push(() => root.classList.remove('sc-mobile-buy-ready'));
      let inboxStyle;
      const positionInbox = () => {
        const shadow = document.querySelector('#smart-bot-container')?.shadowRoot;
        if (!shadow) return false;
        if (!inboxStyle?.isConnected) {
          inboxStyle = document.createElement('style');
          inboxStyle.dataset.splusCameraOffset = 'true';
          shadow.appendChild(inboxStyle);
        }
        const rule = sticky.hidden ? '' : '[aria-label="Open chat window"][aria-haspopup="dialog"]{bottom:132px!important}';
        if (inboxStyle.textContent !== rule) inboxStyle.textContent = rule;
        return true;
      };
      const updateSticky = () => {
        const rect = primary.getBoundingClientRect();
        const overlayOpen = document.querySelector('m-cart-drawer.m-cart-drawer--active, dialog[open], .spn-mobile[open], .spn-search[open]') || document.documentElement.classList.contains('prevent-scroll') || document.documentElement.classList.contains('spn-scroll-lock');
        sticky.hidden = !!overlayOpen || (!window.matchMedia('(max-width:749px)').matches && rect.bottom >= 0);
        positionInbox();
      };
      const observer = new IntersectionObserver(updateSticky,{threshold:0});observer.observe(primary);cleanups.push(()=>observer.disconnect());
      const htmlObserver = new MutationObserver(updateSticky);htmlObserver.observe(document.documentElement,{attributes:true,attributeFilter:['class']});cleanups.push(()=>htmlObserver.disconnect());
      listen(dialog,'close',updateSticky);listen(zoom,'click',updateSticky);
      listen(stickySubmit,'click',()=>{primary.click();});
      let stickyFrame = 0;
      const queueSticky = () => {
        if (stickyFrame) return;
        stickyFrame = requestAnimationFrame(() => { stickyFrame = 0; updateSticky(); });
      };
      listen(window,'scroll',queueSticky,{passive:true});
      cleanups.push(()=>cancelAnimationFrame(stickyFrame));
      listen(window,'resize',updateSticky);
      listen(window,'load',updateSticky);
      const inboxObserver = new MutationObserver(() => { if (positionInbox()) inboxObserver.disconnect(); });
      inboxObserver.observe(document.body,{childList:true,subtree:true});
      cleanups.push(()=>{inboxObserver.disconnect();inboxStyle?.remove();});
      updateSticky();
    }
    root.scCleanup = () => cleanups.forEach(fn => fn());
  }
  const initAll = scope => scope.querySelectorAll('[data-splus-camera]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initAll(document),{once:true});else initAll(document);
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-splus-camera]').forEach(root=>root.scCleanup?.()));
})();
